/**
 * Mavzu tanlash — bosh ekranda, qidiruv qatorining o'ng uchida.
 *
 * UCH HOLAT, ikki emas. "Telegram kabi" — sukut: ilova Telegram
 * mavzusiga ergashadi (u ko'pincha kun vaqtiga qarab o'zi almashadi).
 * Kunduzgi yoki tungi tanlansa, keyingi kirishlarda ham shu qoladi
 * (`setThemePref`). Faqat ikki holatli almashtirgich bo'lsa, bir marta
 * bosgan odam Telegram'ga ergashishga QAYTA OLMASDI.
 *
 * Tugmadagi ikonka hozirgi mavzuni ko'rsatadi (quyosh yoki oy) — tanlov
 * "Telegram kabi" bo'lsa ham.
 */

import { useEffect, useRef, useState, useSyncExternalStore, type ReactNode } from "react";
import { t } from "./i18n";
import type { Key } from "./i18n/uz";
import { IconCheck, IconContrast, IconMoon, IconSun } from "./icons";
import {
  colorScheme,
  haptic,
  onSchemeChange,
  setThemePref,
  themePref,
  type ThemePref,
} from "./telegram";

const OPTIONS: [ThemePref, Key, ReactNode][] = [
  ["auto", "theme.auto", <IconContrast size={18} />],
  ["light", "theme.light", <IconSun size={18} />],
  ["dark", "theme.dark", <IconMoon size={18} />],
];

// Satr — taqqoslash qiymat bo'yicha, har renderda yangi obyekt emas
const snapshot = () => `${themePref()}|${colorScheme()}`;

export function ThemeSwitch() {
  const state = useSyncExternalStore(onSchemeChange, snapshot);
  const [pref, scheme] = state.split("|") as [ThemePref, "light" | "dark"];
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);

  // Tashqariga bosish yoki Escape — menyu yopiladi
  useEffect(() => {
    if (!open) return;
    const onDown = (e: PointerEvent) => {
      if (!rootRef.current?.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("pointerdown", onDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("pointerdown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <div className="theme-switch" ref={rootRef}>
      <button
        className="icon-btn"
        type="button"
        aria-label={t("theme.title")}
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => {
          haptic("light");
          setOpen(!open);
        }}
      >
        {scheme === "light" ? <IconSun size={20} /> : <IconMoon size={20} />}
      </button>
      {open ? (
        <div className="theme-menu" role="menu" aria-label={t("theme.title")}>
          <p className="theme-menu-title">{t("theme.title")}</p>
          {OPTIONS.map(([value, label, icon]) => (
            <button
              key={value}
              className={`theme-option${pref === value ? " theme-option-on" : ""}`}
              type="button"
              role="menuitemradio"
              aria-checked={pref === value}
              onClick={() => {
                haptic("light");
                setOpen(false);
                if (value !== pref) setThemePref(value);
              }}
            >
              {icon}
              <span>{t(label)}</span>
              {pref === value ? <IconCheck size={16} className="theme-option-check" /> : null}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
